
















import { Vue, Component, Watch } from 'vue-property-decorator'
import { Container, Logo, Box, PositiveSubheader } from '../atoms/'
import { REDIRECT_COUNT_DOWN_TIME } from '../../constant/config'
import { mapGetters } from 'vuex'
import { APP_MODULE, TRANSLATE } from '@/store/modules/app/constant'

@Component({
  components: {
    Container,
    Logo,
    Box,
    PositiveSubheader
  },
  computed: {
    ...mapGetters(APP_MODULE, [TRANSLATE])
  }
})
export default class Success extends Vue {
  private redirectCountdown: number = REDIRECT_COUNT_DOWN_TIME

  @Watch('redirectCountdown', {
    immediate: true
  })
  decreaseRedirectCountdown(countdownTime: number) {
    if (countdownTime > 0) {
      setTimeout(() => {
        this.redirectCountdown--
      }, 1000)
    } else {
      const unescapeURI = unescape(this.$route?.query?.redirect_uri.toString()) as string
      location.replace(unescapeURI || '/')
    }
  }
  get userEmail() {
    return this.$route?.query?.e
  }
}
